import type { FaireProductEntity } from "../../entity_types/product";

export const p_4hdffrs9us: FaireProductEntity = {
  token: "p_4hdffrs9us",
  type: "product",
  name: "Hawaii Volcanoes National Park",
  brandToken: "b_c251hgcw2g",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/cd3eed2cce6555e2f0ea5bd87f7026297af01e4554419b4560aec75ee3192078.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5b5e2be92ab913a79f4048213e92972067709b1dd428a50d829f73d0f726e34a.jpeg",
    "https://cdn.faire.com/fastly/09e7099a4a0060cc76bf3272d753418bb71587e39f438ac1d3cd727a26080544.jpeg",
    "https://cdn.faire.com/fastly/cf5f0c658b7eb0258dbe1ab21f117ed2b1303e4835fdfba89cd69c3d5376d30b.jpeg",
  ],
  priceDollars: 20.75,
  description:
    "Hawaii Volcanoes National Park Adult Crew Neck Tee. 50% Cotton, 50% Polyester Premium Vintage Jersey\n\n\n",
  tags: [],
  msrpDollars: 41.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:25.757Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
